export enum DisplayStyles {
  Default = 'default',
  Inline = 'inline',
}
